import { Link } from "react-router-dom";
import { Phone, ClipboardList } from "lucide-react";
import { site } from "@/config/site";
import { trackEvent } from "@/lib/analytics";

export function MobileBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-slate-950/95 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-sticky-bar"
    >
      <div className="grid grid-cols-2 gap-3 px-4 py-3">
        <a
          href={site.phoneHref}
          data-testid="mobile-bar-call"
          onClick={() => trackEvent("phone_click", { location: "mobile-bar" })}
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-ember/60 text-sm font-semibold text-ember transition-colors duration-200 hover:bg-ember/10"
        >
          <Phone className="h-4 w-4" aria-hidden="true" /> Call
        </a>
        <Link
          to="/estimate"
          data-testid="mobile-bar-estimate"
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-ember text-sm font-semibold text-white shadow-lg shadow-orange-900/40 transition-colors duration-200 hover:bg-ember-dark"
        >
          <ClipboardList className="h-4 w-4" aria-hidden="true" /> Free Estimate
        </Link>
      </div>
    </div>
  );
}
